/* eslint-disable import/prefer-default-export */
import { Address, AddressV2 } from "api/models";
import { Highlighter } from "react-bootstrap-typeahead";
import { IcontactOptionProps, IOptionProps } from "../Types";

export const formatAddress = (address: Address) => ({
  id: address.id,
  value: address.name,
  label: address.name || "",
  zipcode: address.zipcode || "",
  city_name: address.city_name || "",
  street_address: address.street_address || "",
  country_name: address.country_name || "",
  country_code: address.country?.code,
  timezone: address.timezone,
  state_name: address?.state_name,
  last_used_contact_id: address.last_used_contact_id,
  reference_number: address.reference_number,

  street_address_line_two: address.street_address_line_two,
  un_locode: address.un_locode,
  location_reference_number: address.location_reference_number,
  custom_address_reference: address.custom_address_reference,
});

export const formatAddressV2 = (address: AddressV2) => ({
  id: address.id,

  value: address.name,
  label: address.name || "",
  street_address: address.street_address || "",
  street_address_line_two: address.street_address_line_two,
  zipcode: address.zipcode || "",

  country_name: address.country_name || "",
  country_id: address.country_id,
  state_name: address?.state_name,
  state_id: address?.state_id,
  city_name: address.city_name || "",
  city_id: address.city_id,

  timezone: address.timezone,
  reference_number: address.reference_number,

  un_locode: address.un_locode,
  location_reference_number: address.location_reference_number,
  custom_address_reference: address.custom_address_reference,
});

export function AddressOption({ option }: { option: IOptionProps }) {
  return (
    <div style={{ fontSize: "11px", lineHeight: "14px" }}>
      <div className="font-bold">{option?.label}</div>
      <div className="mt-xs">
        {option?.street_address}
        {option?.street_address_line_two && `, ${option?.street_address_line_two}`} <br />
        {option?.city_name && `${option?.city_name}`}
        {option?.state_name && `, ${option?.state_name}`}
        {option?.zipcode && ` ${option?.zipcode}`} <br />
        {option?.country_name && `${option?.country_name}`}
      </div>
      {option?.un_locode && <div className="mt-xs">UN/LOCODE: {option?.un_locode}</div>}
      {(option?.location_reference_number || option?.custom_address_reference) && (
        <div className="mt-xs text-secondary">
          {option?.location_reference_number}
          {option?.location_reference_number && option?.custom_address_reference && " | "}
          {option?.custom_address_reference}
        </div>
      )}
    </div>
  );
}

export const handleContactRenderOption = ({ option, text }: { option: IcontactOptionProps; text: string }) => (
  <div className="p-1">
    <div className="font-weight-bold font-12">
      <Highlighter search={text}>{option.label}</Highlighter>
    </div>
    <div className="font-b5 mt-1 text-secondary">{option.company_name}</div>
  </div>
);
